<template>
  <div id="AdvancedOptions" ref="container">
    <div class="content_area">
      <div class="left_nav">
        <div @click="SdLeftClick(item,'leftList')" :class="item.num===navCall?'navSelected':''"
             v-for="item in NavList"
             :key="item.num">
          {{ item.title }}
        </div>
      </div>
      <div class="form_wrap">
        <div class="toolsIntroduce">
          <div class="left">
            <img src="../img/face.png" alt="">
          </div>
          <div class="right">
            <p>
              功能介绍
            </p>
            <span v-if="navCall===1" style="display: block">
              基于 Stable Diffusion 2.0模型进行绘画创作，能根据文本描述生成逼真图像
            </span>
            <span v-if="navCall===2" style="display: block">
                基于 Stable Diffusion 2.0模型进行绘画创作，根据已有图像生成新的图像
            </span>
            <span v-if="navCall===3" style="display: block">
               高级SD绘画玩法，开放更多参数设置，可根据特定条件生成图像，通过设置参数控制生成效果
            </span>
            <span v-if="navCall===4" style="display: block">
               基于 Stable Diffusion 3.0最新模型进行绘画创作，超强的绘画理解能力，一句话生成高清画质作品
            </span>
          </div>
        </div>
        <div class="options_item" v-if="navCall===3">
          <div class="item_title" flex-align>
            <div class="text">上传参考图（必填）</div>
          </div>
          <div class="Reference_image">
            <el-upload
                class="upload-demo"
                drag
                :action="fileApi+'/api/front/upload/?fdir=mj_iw'"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                multiple>
              <div v-if="imageUrl" class="yesUpload">
                <img :src="imageUrl" alt="" class="yesUpload_img">
                <div class="yesUpload_icon" @click.stop="imageUrl=''">
                  <i class="el-icon-delete"></i>
                </div>
              </div>
              <div v-else class="noUpload">
                <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                <div> 只能上传jpg/png文件，且不超过10MB</div>
              </div>
            </el-upload>
          </div>
        </div>

        <div class="options_item" v-if="navCall===3">
          <div class="item_title" flex-align>
            <div class="text">条件控制-ControlNet</div>
          </div>
          <div class="ControlNet" @click="showDefeatPopup('showDefeat')">
            <div class="ControlNet_one" v-if="conditionListSelect.length<1">
              添加条件模型
            </div>
            <div v-else class="ControlNet_two">
              <div class="left">
                <div class="conditionSelect" v-for="(item,index) in conditionListSelect">
                  <span class="reduce">-</span>
                  <span class="title">{{ item.title }} {{ item.scale }}</span>
                  <div class="add">+</div>
                </div>
              </div>
              <div class="right">
                选择
              </div>
            </div>
          </div>
        </div>

        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">{{ navCall === 3 ? '正向提示词-Prompt（选填）' : '绘画描述' }}</div>
          </div>
          <div class="btm_area_con">
            <div>
                <textarea class="text" rows="4" v-model="inputVal"
                          placeholder="输入绘画描述词，描述词越详细生成的图片效果更佳~"></textarea>
            </div>
            <div class="depict_switch">
              <div class="switch">
                <el-switch
                    style="zoom: 0.7"
                    @change="getPromptData4()"
                    active-value="1"
                    inactive-value="0"
                    active-color="#5865f2"
                    inactive-color="#53555f"
                    v-model="auto_spell">
                </el-switch>
                <span>一键优化描述词</span>
              </div>
              <div class="empty" @click="inputVal=''">清空</div>
            </div>
          </div>
        </div>
        <div class="options_item" v-if="navCall===3">
          <div class="item_title" flex-align>
            <div class="text">通用底模-checkpoint</div>
          </div>
          <div class="checkpoint">
            <div @click="checkpoint=item.num" :class="checkpoint===item.num?'checkpoint_items':'checkpoint_item'"
                 v-for="item in checkpointList">
              <img :src="item.img" alt="">
              <div>
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>

        <div class="options_item" v-if="navCall===2">
          <div class="item_title" flex-align>
            <div class="text">图片选择</div>
          </div>
          <div class="picture_sel">
            <div class="picture_top">
              <div class="upload_img"
                   :style="{border:imageUrl?'none':'1px dashed #cedffe80', backgroundImage: `url(${imageUrl})`,backgroundSize: 'cover', backgroundPosition: 'center', width: '100px', height: '100px' }">

                <el-upload
                    class="avatar-uploader"
                    :action="fileApi+'/api/front/upload/?fdir=mj_iw'"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                  <div v-if="imageUrl" @click.stop="imageUrl=''" class="hoverImg">
                    <i class="el-icon-delete"></i>
                  </div>
                  <div v-if="!imageUrl" class="noUpload">
                    <div>
                      <i class="el-icon-plus"></i>
                    </div>
                    <div class="noUpload_text">
                      上传文件风格
                    </div>
                  </div>
                </el-upload>
              </div>
              <div class="style_strength">
                <div class="strength_top">
                  <span>风格图强度</span><span>{{ value1 }}%</span>
                </div>
                <div class="strength_bot">
                  <el-slider color="#5865f2" v-model="value1"></el-slider>
                </div>
              </div>
            </div>
            <div class="picture_bot">
              <div>
                <div class="one">锁定人脸特征</div>
                <div class="two">请确保风格图中包含人脸</div>
              </div>
              <div class="three">
                <span>关闭</span>
                <el-switch active-color="#5865f2" inactive-color="#53555f" v-model="switch1">
                </el-switch>
              </div>
            </div>
          </div>
        </div>

        <div class="options_item" v-if="navCall===2||navCall===1">
          <div class="item_title" flex-align>
            <div class="text">LORA风格选择</div>
          </div>
          <div class="toolsModelList">
            <div class="music_style">
                <span :class="clickImgStyle.sign===item.sign?'spanColor':''"
                      v-for="item in musicStyle"
                      @click="clickLoraStyleList(item)">
                  {{ item.style }}
                </span>
            </div>
            <div class="music_styleImg" :style="{height:clickImgStyle.shou?expand?270+'px':'auto':'auto'}">
              <div @click="clickImgStyle.num=item.num"
                   :class="clickImgStyle.num===item.num? 'item_click':'styleImg_item'"
                   v-for="item in clickImgStyleList" v-if="item.sign.includes(clickImgStyle.sign) ">
                <img alt="" :src="item.src">
                <div>
                  {{ item.title }}
                </div>
              </div>
            </div>
            <div class="upDown" @click="expand=!expand" v-if="clickImgStyle.shou">
              <img v-if="expand" alt="" src='./img/down.png' height="14" width="15"/>
              <img v-if="!expand" alt="" src="./img/upward.png" height="13" width="14"/>
            </div>
          </div>
        </div>

        <div class="options_item" v-if="navCall===3">
          <div class="item_title" flex-align>
           <span style="display: flex;justify-content: space-between;flex:1;">
                <span class="text">融合风格-Lora</span>
                <span @click="showDefeatPopup('loraStyle')"
                      style="color: #b4b9bf;font-size: 14px;cursor:pointer;">+去添加</span>
              </span>
          </div>
          <div class="fusionStyle">
            <div v-if="LoraListSelect.length===0" class="fusionStyle_one" @click="showDefeatPopup('loraStyle')">
              <div class="fusionStyle_oneLeft">
                <div>点击</div>
                <div>添加</div>
              </div>
              <div class="fusionStyle_oneRight">
                <span>叠加风格</span>
                <div>在底膜的基础上进行风格叠加融合</div>
              </div>
            </div>
            <div v-else class="fusionStyle_two">
              <div class="two_Imgs" v-for="(item,index) in LoraListSelect">
                <div class="two_Img">
                  <img :src="item.src" alt="">
                  <div class="closes" @click="clickLoraList(item,index,'delete')">
                    <i class="el-icon-error"></i>
                  </div>
                  <div class="title">
                    {{ item.title }}
                  </div>
                </div>
                <div class="two_bot">
                  <div @click="clickLoraList(item,index,'reduce')"> -</div>
                  <div>权重 {{ item.scale }}</div>
                  <div @click="clickLoraList(item,index,'adds')"> +</div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="options_item" v-if="navCall===3||navCall===4">
          <div class="item_title" flex-align>
            <div class="text">高级参数</div>
          </div>
          <div class="parameter">
            <div class="parameter_title">
              采样步数-Sampling Steps
            </div>
            <div class="parameter_slider">
              <div class="slider_num">
                {{ sampLingSteps }}
              </div>
              <div class="slider">
                <el-slider :min="25" :max="35" v-model="sampLingSteps"></el-slider>
              </div>
            </div>
            <div class="parameter_title">
              提示词相关性-CFG scale
            </div>
            <div class="parameter_slider">
              <div class="slider_num">
                {{ cfgScale }}
              </div>
              <div class="slider">
                <el-slider :min="3" :max="7" v-model="cfgScale"></el-slider>
              </div>
            </div>
            <div class="parameter_title">
              负面提示词-Negative Prom
            </div>
            <div class="Negative_Prom">
                <textarea class="Negative_text" v-model.trim="negativeText" placeholder="请输入不想出现的元素" name=""
                          id=""
                          cols="30" rows="10"></textarea>
            </div>
          </div>
        </div>
        <div class="options_item" v-if="navCall!==3">
          <div class="item_title flex jb ac ">
            <div class="text">
              生成尺寸
              <span class="fz12" style="margin-left: 10px;color: #6D6D6D;">选择生成图像的宽度×高度比例</span>
            </div>
          </div>
          <div class="item_con">
            <div class="size_list flex">
              <div class="size_item flex fc jc ac" :class="form.aspect == item.size ? 'active' : ''"
                   @click="choose_aspect(item)" v-for="(item, index) in img_size" :key="index">
                <img :src="require('../img/s' + (index + 1) + '.png')"/>
                <p>{{ item.size }}</p>
                <p>{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">绘图模式</div>
          </div>
          <div class="drawingMode">
            <div @click="drawingModeNum=item.num" :class="drawingModeNum===item.num?'mode':'itemMode'"
                 v-for="item in drawingMode">
              {{ item.title }}
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="bottom_area" flex-center>
      <div class="primary_button" @click="sendMsg" v-loading="sending">提交任务<span
          style="font-size: 12px">（消耗{{ drawingModeNum }}积分）</span></div>
    </div>

    <popup ref="conditionPopup"
           type="center"
           @close="defeatPopClose('showDefeat')">
      <div class="condition_Popup">
        <div class="conditionTop">
          <div>
            条件预处理器选择（{{ conditionListSelect.length }}/2）
          </div>
          <div class="clear" @click="defeatPopClose('showDefeat')">
            <i class="el-icon-error"></i>
          </div>
        </div>
        <div class="conditionTips">
          指定条件控制图生图，最多选择2个哦~
        </div>
        <div class="conditionShow" v-if="conditionListSelect.length>0">
          <div class="conditionSelect" v-for="(item,index) in conditionListSelect">
            <span @click="clickConditionList(item,index,'reduce')" class="reduce">-</span>
            <span class="title"><span>{{ item.title }}</span> {{ item.scale }}</span>
            <div @click="clickConditionList(item,index,'adds')" class="add">+</div>
          </div>
        </div>
        <div class="condition_List">
          <div @click="clickConditionList(item,index,'add')" :class="!item.select?'List_itme':'List_itmes'"
               v-for="(item,index) in conditionList">
            <div class="item_img">
              <img :src="require('./img/0'+(index+1)+'.png')" alt="">
            </div>
            <div class="title">
              <div>{{ item.title }}</div>
              <span style="display: block">{{ item.explain }}</span>
            </div>
          </div>
        </div>
        <div class="conditionBtn">
          <div @click="clickConditionList('item','index','clear')">重置</div>
          <div @click="defeatPopClose('showDefeat')">确定</div>
        </div>
      </div>
    </popup>

    <popup ref="loraStyle"
           type="center"
           @close="defeatPopClose('loraStyle')">
      <div class="loraStyle_Popup">
        <div class="conditionTop">
          <div>
            融合Lora模型（{{ LoraListSelect.length }} / 2）
          </div>
          <div class="clear" @click="defeatPopClose('loraStyle')">
            <i class="el-icon-error"></i>
          </div>
        </div>
        <div class="conditionTips">
          在主模型的基础上进行风格叠加融合。注意不要融太多和比例太高，容易造成崩图哦~
        </div>
        <div class="conditionShow" v-if="LoraListSelect.length>0">
          <div class="conditionSelect" v-for="(item,index) in LoraListSelect">
            <span @click="clickLoraList(item,index,'reduce')" class="reduce">-</span>
            <span class="title">{{ item.title }} {{ item.scale }}</span>
            <div @click="clickLoraList(item,index,'adds')" class="add">+</div>
          </div>
        </div>
        <div class="music_style">
                <span :class="LoraListStyle.sign===item.sign?'spanColor':''"
                      v-for="item in musicStyle"
                      @click="clickLoraStyleList(item,true)">
                  {{ item.style }}
                </span>
        </div>
        <div class="condition_List">
          <!--              <div class="music_styleImg" :style="{height:expand?270+'px':'auto'}">-->
          <div class="music_styleImg">
            <div @click="clickLoraList(item,index,'add')"
                 :class="item.select? 'item_click':'styleImg_item'"
                 v-for="(item,index) in clickImgStyleList" v-if="item.sign.includes(LoraListStyle.sign)">
              <img alt="" :src="item.src">
              <!--              :class="item.select? 'item_click':'styleImg_item'"-->
              <div>
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
        <div class="conditionBtn">
          <div @click="clickLoraList('','','clear')">重置</div>
          <div @click="defeatPopClose('loraStyle')">确定</div>
        </div>
      </div>
    </popup>
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>

  </div>
</template>

<script>
import popup from "COMPONENTS/Popup.vue"
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import utils from "@/utils/index.js"
export default {
  components: {faceVerifyPopup, popup},
  props: ['sampleList'],
  data() {
    return {
      //展示隐藏search_tips
      inputVal: "",
      sending: false,
      search_tips: false,
      //模型列表
      model_list: [{
        img_url: "/static/img/mode/nj6.0.png",
        name: "NJ6.0",
        title: 'NJ6.0(动漫质感)',
        desc: '官方最新动漫模型同步',
      }, {
        img_url: "/static/img/mode/mj6.0.png",
        name: "MJ6.0",
        title: 'MJ6.0(真实质感)',
        desc: '全新6.0 ALPHA真实风格图像',
      }],
      is_fast: 1,
      //当前选中模型
      img_model: 'NJ6.0',
      fileList: [],
      iw_options: [
        {label: '关闭iw选项', value: '0'},
        {label: '--iw 0.25 相似度30%', value: '0.25'},
        {label: '--iw 0.5 相似度40%', value: '0.5'},
        {label: '--iw 1 相似度50%', value: '1'},
        {label: '--iw 1.25 相似度60%', value: '1.25'},
        {label: '--iw 1.5 相似度70%', value: '1.5'},
        {label: '--iw 1.75 相似度80%', value: '1.75'},
        {label: '--iw 2 相似度90%', value: '2'},
      ],
      img_size: [
        {size: '1:1', title: '头像框'},
        {size: '1:2', title: '手机壁纸'},
        {size: '16:9', title: '电脑壁纸'},
        {size: '9:16', title: '宣传海报'},
        {size: '4:3', title: '文章配图'},
        {size: '3:4', title: '媒体配图'},
        {size: '3:2', title: '横版名片'},
        {size: '2:3', title: '小红书图'},
      ],
      qualityImg: [
        {name: '标准', num: 0,},
        {name: '高清', num: 100,},
      ],
      iw: "0.25",
      upload_img_url: "",
      form: {
        iw: 0.02 * this.value1,
        aspect: "1:1",// 大小比例
        is_public: '0',//是否公开作品
        quality: 0,
        stylize: 100,
        chaos: 0,
        upload_list: []
      },
      fileApi: FILE_API_SERVER,
      upoadLoading: false,
      uploadError: '',
      okNum: 0,
      totalNum: 0,
      isWxEnv: false,
      // sd绘画左侧信息
      navCall: 1,
      NavList: [
        {title: '文生图', num: 1,},
        {title: '图生图', num: 2,},
        {title: '条件生图', num: 3,},
        {title: 'SD3', num: 4,},
      ],
      musicStyle: [
        {style: '推荐', sign: 1, num: 1, shou: true,},
        {style: '七夕', sign: 2, num: 12, shou: false,},
        {style: '游戏', sign: 3, num: 40, shou: true,},
        {style: '女生', sign: 4, num: 3, shou: true,},
        {style: '男生', sign: 5, num: 59, shou: true,},
        {style: '动漫风', sign: 6, num: 13, shou: true,},
        {style: '3D立体', sign: 7, num: 86, shou: false,},
        {style: '艺术创作', sign: 8, num: 8, shou: true,},
        {style: '中国风', sign: 9, num: 64, shou: false,},
        {style: '建筑设计', sign: 10, num: 105, shou: false,},
        {style: 'LOGO图标', sign: 11, num: 109, shou: false,},
      ],
      clickImgStyle: {num: 1, sign: 1, shou: true,},
      clickImgStyleList: [
        {num: 1, sign: [1], title: '默认动漫', select: false, scale: 0.8, src: require('./img/57.png'),},
        {num: 2, desc: "MJ6.0", sign: [1], title: '默认写实', select: false, scale: 0.8, src: require('./img/56.png'),},
        {
          num: 3,
          desc: "MJ6.0",
          sign: [1, 4],
          title: '默认摄影',
          select: false,
          scale: 0.8,
          src: require('./img/55.png'),
        },
        {num: 4, sign: [1], title: '默认动漫2.0', select: false, scale: 0.8, src: require('./img/54.png'),},
        {num: 5, desc: "MJ6.0", sign: [1], title: '全能模型', select: false, scale: 0.8, src: require('./img/53.png'),},
        {
          num: 6,
          desc: "MJ6.0",
          sign: [1, 4],
          title: '东方美女',
          select: false,
          scale: 0.8,
          src: require('./img/52.png'),
        },
        {
          num: 7,
          desc: "MJ6.0",
          sign: [1, 4],
          title: '人与自然',
          select: false,
          scale: 0.8,
          src: require('./img/51.png'),
        },
        {num: 8, sign: [1, 8], title: '机械甲虫', select: false, scale: 0.8, src: require('./img/50.png'),},
        {num: 9, sign: [1, 8], title: '风格悬疑', select: false, scale: 0.8, src: require('./img/49.png'),},
        {num: 10, sign: [1, 8], title: '日式悬疑', select: false, scale: 0.8, src: require('./img/48.png'),},
        {num: 11, sign: [1, 8], title: '中式悬疑', select: false, scale: 0.8, src: require('./img/47.png'),},
        {num: 12, sign: [1, 2], title: '双人插画', select: false, scale: 0.8, src: require('./img/46.png'),},
        {num: 13, sign: [1, 6], title: '轻线条', select: false, scale: 0.8, src: require('./img/45.png'),},
        {num: 14, sign: [1, 6, 8], title: '儿童绘本', select: false, scale: 0.8, src: require('./img/44.png'),},
        {num: 15, sign: [1, 6, 8], title: '像素世界', select: false, scale: 0.8, src: require('./img/43.png'),},
        {num: 16, sign: [1, 8], title: '玉石质感', select: false, scale: 0.8, src: require('./img/42.png'),},
        {num: 17, sign: [1, 6], title: '商业插画', select: false, scale: 0.8, src: require('./img/41.png'),},
        {num: 18, sign: [1, 6], title: '潦草画风', select: false, scale: 0.8, src: require('./img/40.png'),},
        {num: 19, sign: [1, 6], title: '涂鸦风格', select: false, scale: 0.8, src: require('./img/39.png'),},
        {num: 20, sign: [1, 4, 8], title: '炫彩少女', select: false, scale: 0.8, src: require('./img/38.png'),},
        {num: 21, sign: [1, 6], title: '小清新', select: false, scale: 0.8, src: require('./img/37.png'),},
        {num: 22, sign: [1, 8], title: '彩泥幻境', select: false, scale: 0.8, src: require('./img/36.png'),},
        {num: 23, sign: [1, 8], title: '西游神话', select: false, scale: 0.8, src: require('./img/35.png'),},
        {num: 24, sign: [1, 6], title: '治愈动画', select: false, scale: 0.8, src: require('./img/34.png'),},
        {num: 25, sign: [1, 8,], title: '全息科技', select: false, scale: 0.8, src: require('./img/33.png'),},
        {num: 26, sign: [1, 8,], title: '水彩插画', select: false, scale: 0.8, src: require('./img/32.png'),},
        {
          num: 27,
          desc: "MJ6.0",
          sign: [1, 4],
          title: '韩流写真',
          select: false,
          scale: 0.8,
          src: require('./img/31.png'),
        },
        {num: 28, sign: [1, 8,], title: '潮流机械', select: false, scale: 0.8, src: require('./img/30.png'),},
        {num: 29, sign: [1, 8,], title: '跳跃色彩', select: false, scale: 0.8, src: require('./img/29.png'),},
        {num: 30, sign: [1, 2, 8,], title: '玫瑰花海', select: false, scale: 0.8, src: require('./img/28.png'),},
        {num: 31, sign: [1, 2, 6], title: '原谅色', select: false, scale: 0.8, src: require('./img/27.png'),},
        {num: 32, sign: [1, 2, 6], title: '情绪插画', select: false, scale: 0.8, src: require('./img/26.png'),},
        {num: 33, sign: [1, 2, 6], title: '放纵自由', select: false, scale: 0.8, src: require('./img/25.png'),},
        {num: 34, sign: [4], title: '古典敦煌', select: false, scale: 0.8, src: require('./img/58.png'),},
        {
          num: 35,
          desc: "MJ6.0",
          sign: [4],
          title: '港风胶片',
          select: false,
          scale: 0.8,
          src: require('./img/59.png'),
        },
        {
          num: 36,
          desc: "MJ6.0",
          sign: [4],
          title: '霓虹灯光',
          select: false,
          scale: 0.8,
          src: require('./img/60.png'),
        },
        {num: 37, sign: [4], title: '九尾妖狐', select: false, scale: 0.8, src: require('./img/61.png'),},
        {num: 38, sign: [4], title: '狐妖面具', select: false, scale: 0.8, src: require('./img/62.png'),},
        {num: 39, sign: [4], title: '白月光', select: false, scale: 0.8, src: require('./img/63.png'),},
        {num: 40, sign: [3], title: '原-lumine', select: false, scale: 0.8, src: require('./img/64.png'),},
        {num: 41, sign: [3], title: '原-PAIMON', select: false, scale: 0.8, src: require('./img/65.png'),},
        {num: 42, sign: [3], title: '原-YELAN', select: false, scale: 0.8, src: require('./img/66.png'),},
        {num: 43, sign: [3], title: '原-NINGGUANG', select: false, scale: 0.8, src: require('./img/67.png'),},
        {num: 44, sign: [3], title: '原-EULA', select: false, scale: 0.8, src: require('./img/68.png'),},
        {num: 45, sign: [3], title: '原-NILOU', select: false, scale: 0.8, src: require('./img/69.png'),},
        {num: 46, sign: [3], title: '原-BARBARA', select: false, scale: 0.8, src: require('./img/70.png'),},
        {num: 47, sign: [3], title: '原-KEQING', select: false, scale: 0.8, src: require('./img/71.png'),},
        {num: 48, sign: [3], title: '原-YOIMIYA', select: false, scale: 0.8, src: require('./img/72.png'),},
        {num: 49, sign: [3], title: '原-HUTAO', select: false, scale: 0.8, src: require('./img/73.png'),},
        {num: 50, sign: [3], title: '原-MIKO', select: false, scale: 0.8, src: require('./img/74.png'),},
        {num: 51, sign: [3], title: '原-GANYU', select: false, scale: 0.8, src: require('./img/75.png'),},
        {num: 52, sign: [3], title: '原-KOKOMI', select: false, scale: 0.8, src: require('./img/76.png'),},
        {num: 53, sign: [3], title: '原-SHENHE', select: false, scale: 0.8, src: require('./img/77.png'),},
        {num: 54, sign: [3], title: '原-AYAKA', select: false, scale: 0.8, src: require('./img/78.png'),},
        {num: 55, sign: [3], title: '原-KLEE', select: false, scale: 0.8, src: require('./img/79.png'),},
        {num: 56, sign: [3], title: '原-SHOGUN', select: false, scale: 0.8, src: require('./img/80.png'),},
        {num: 57, sign: [3], title: '原-NAHIDA', select: false, scale: 0.8, src: require('./img/81.png'),},
        {num: 58, sign: [3], title: '原-FURINA', select: false, scale: 0.8, src: require('./img/82.png'),},
        {num: 59, sign: [5], title: '正义-警车', select: false, scale: 0.8, src: require('./img/83.png'),},
        {num: 60, sign: [5], title: '正义-跑车', select: false, scale: 0.8, src: require('./img/84.png'),},
        {num: 61, sign: [5], title: '正义-警', select: false, scale: 0.8, src: require('./img/85.png'),},
        {num: 62, sign: [5], title: '正义-小丑', select: false, scale: 0.8, src: require('./img/86.png'),},
        {num: 63, sign: [5], title: '关云长', select: false, scale: 0.8, src: require('./img/87.png'),},
        {num: 64, sign: [5, 9,], title: '古装男神', select: false, scale: 0.8, src: require('./img/88.png'),},
        {num: 65, sign: [5, 6], title: '痞帅男风', select: false, scale: 0.8, src: require('./img/89.png'),},
        {num: 66, sign: [5, 6], title: '治愈男生', select: false, scale: 0.8, src: require('./img/90.png'),},
        {num: 67, sign: [5, 6], title: '厚插画男生', select: false, scale: 0.8, src: require('./img/91.png'),},
        {num: 68, sign: [5], title: '国风少侠', select: false, scale: 0.8, src: require('./img/92.png'),},
        {num: 69, sign: [6,], title: '复古动漫', select: false, scale: 0.8, src: require('./img/93.png'),},
        {num: 70, sign: [6,], title: '冷淡风', select: false, scale: 0.8, src: require('./img/94.png'),},
        {num: 71, sign: [6,], title: '治愈女生', select: false, scale: 0.8, src: require('./img/95.png'),},
        {num: 72, sign: [6,], title: '表情大师', select: false, scale: 0.8, src: require('./img/96.png'),},
        {num: 73, sign: [6,], title: '大乱斗', select: false, scale: 0.8, src: require('./img/97.png'),},
        {num: 74, sign: [6,], title: '卡通手绘', select: false, scale: 0.8, src: require('./img/98.png'),},
        {num: 75, sign: [6,], title: '涂鸦线条', select: false, scale: 0.8, src: require('./img/99.png'),},
        {num: 76, sign: [6,], title: '漫画线条', select: false, scale: 0.8, src: require('./img/100.png'),},
        {num: 77, sign: [6,], title: '沙雕手绘', select: false, scale: 0.8, src: require('./img/101.png'),},
        {num: 78, sign: [6,], title: '龙年头像', select: false, scale: 0.8, src: require('./img/102.png'),},
        {num: 79, sign: [6,], title: '龙年幻彩', select: false, scale: 0.8, src: require('./img/103.png'),},
        {num: 80, sign: [6,], title: '国风扁平插画', select: false, scale: 0.8, src: require('./img/104.png'),},
        {num: 81, sign: [6,], title: 'Q版简绘', select: false, scale: 0.8, src: require('./img/105.png'),},
        {num: 82, sign: [6,], title: '儿童绘本插画', select: false, scale: 0.8, src: require('./img/106.png'),},
        {num: 83, sign: [6,], title: '故事书插画', select: false, scale: 0.8, src: require('./img/107.png'),},
        {num: 84, sign: [6,], title: '幻想机甲', select: false, scale: 0.8, src: require('./img/108.png'),},
        {num: 85, sign: [6,], title: '可爱盲盒', select: false, scale: 0.8, src: require('./img/109.png'),},
        {num: 86, sign: [7,], title: 'Q版3D', select: false, scale: 0.8, src: require('./img/110.png'),},
        {num: 87, sign: [7,], title: '黏土风', select: false, scale: 0.8, src: require('./img/111.png'),},
        {num: 88, sign: [7,], title: 'Q版3D三视图', select: false, scale: 0.8, src: require('./img/112.png'),},
        {num: 89, sign: [7,], title: '3D皮克斯', select: false, scale: 0.8, src: require('./img/113.png'),},
        {num: 90, sign: [7,], title: '3D人物', select: false, scale: 0.8, src: require('./img/114.png'),},
        {num: 91, sign: [8,], title: '头像素描', select: false, scale: 0.8, src: require('./img/115.png'),},
        {num: 92, sign: [8,], title: '毛毡娃娃', select: false, scale: 0.8, src: require('./img/116.png'),},
        {num: 93, sign: [8,], title: '剪纸山水', select: false, scale: 0.8, src: require('./img/117.png'),},
        {num: 94, sign: [8,], title: '西方蛟龙', select: false, scale: 0.8, src: require('./img/118.png'),},
        {num: 95, sign: [8,], title: '东方神龙', select: false, scale: 0.8, src: require('./img/119.png'),},
        {num: 96, sign: [8,], title: '电商产品', select: false, scale: 0.8, src: require('./img/120.png'),},
        {num: 97, sign: [8,], title: '油画', select: false, scale: 0.8, src: require('./img/121.png'),},
        {num: 98, sign: [8,], title: '写实增强', select: false, scale: 0.8, src: require('./img/122.png'),},
        {num: 99, sign: [8,], title: '速写风', select: false, scale: 0.8, src: require('./img/123.png'),},
        {num: 100, sign: [9,], title: '国风盲盒', select: false, scale: 0.8, src: require('./img/124.png'),},
        {num: 101, sign: [9,], title: '美丽风景', select: false, scale: 0.8, src: require('./img/125.png'),},
        {num: 102, sign: [9,], title: '中式风景', select: false, scale: 0.8, src: require('./img/126.png'),},
        {num: 103, sign: [9,], title: '水墨画', select: false, scale: 0.8, src: require('./img/127.png'),},
        {num: 104, sign: [9,], title: '水墨山水', select: false, scale: 0.8, src: require('./img/128.png'),},
        {num: 105, sign: [10,], title: '现代建筑', select: false, scale: 0.8, src: require('./img/129.png'),},
        {num: 106, sign: [10,], title: '轻奢风室内', select: false, scale: 0.8, src: require('./img/130.png'),},
        {num: 107, sign: [10,], title: '通用室内设计', select: false, scale: 0.8, src: require('./img/131.png'),},
        {num: 108, sign: [10,], title: '现代北欧', select: false, scale: 0.8, src: require('./img/132.png'),},
        {num: 109, sign: [11,], title: '高级LOGO', select: false, scale: 0.8, src: require('./img/133.png'),},
        {num: 110, sign: [11,], title: '极简LOGO', select: false, scale: 0.8, src: require('./img/134.png'),},
      ],
      expand: true,
      drawingMode: [
        {num: 2, title: '单图模式',},
        {num: 4, title: '四图模式',},
      ],
      drawingModeNum: 2,
      imageUrl: null,
      value1: 60,
      switch1: true,
      //条件控制
      conditionListSelect: [],
      conditionList: [
        {num: 1, scale: 0.8, select: false, title: '线稿渲染Lineart', explain: '按照轮廓绘制，适合草图上色',},
        {num: 2, scale: 0.8, select: false, title: '边缘检测 Canny', explain: '提取线稿进行绘制，更好的保留图片的细节',},
        {num: 3, scale: 0.8, select: false, title: '素描上色 Recolor', explain: '精准保持素描图轮廓进行简笔上色',},
        {num: 4, scale: 0.8, select: false, title: '深度检测 Depth', explain: '根据上传图片的深度信息生成新的图片',},
        {num: 5, scale: 0.8, select: false, title: '软边缘 Hed', explain: '精确保留角色细节，适用于变换服饰和背景',},
        {num: 6, scale: 0.8, select: false, title: '色块分割 Seg', explain: '根据提供的色块进行分割处理',},
        {num: 7, scale: 0.8, select: false, title: '室内设计 M-Lsd', explain: '根据上传图片的深度信息生成新的图片',},
        {
          num: 8,
          scale: 0.8,
          select: false,
          title: '细节增强 Tile',
          explain: '保持构图不变的情况下，对原图的细节进行增强',
        },
        {num: 9, scale: 0.8, select: false, title: '姿态检测 Openpose', explain: '仅用于姿态检测，不检测人脸',},
        {num: 10, scale: 0.8, select: false, title: '脸、手、身体Openpose', explain: '全身的姿态检测，更加完整',},
      ],
      // 高级参数
      sampLingSteps: 28,
      cfgScale: 4,
      negativeText: '',
      //通用底模
      checkpoint: 1,
      checkpointList: [
        {num: 1, title: '动漫', img: require('./img/57.png'),},
        {num: 2, title: '写实', img: require('./img/56.png'),},
        {num: 3, title: '摄影', img: require('./img/55.png'),},
        {num: 4, title: '动漫2.0', img: require('./img/54.png'),},
        {num: 5, title: '全能模型', img: require('./img/53.png'),},
      ],
      // 融合风格-Lora
      LoraListSelect: [],
      LoraListStyle: {num: 1, sign: 1, shou: true,},
      perIncan: false, // ai提示词是否返回
      auto_spell: '1', // ai提示词是否关闭
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    tips_list() {
      return this.sampleList.slice(this.sampleList.length - 20, this.sampleList.length)
    },
    isInputtype() {
      return this.$store.state.isInputtype;
    },
    isInputVal() {
      return this.$store.state.isInputVal;
    },
  },
  created() {
    var ua = navigator.userAgent.toLowerCase();
    if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
      this.isWxEnv = true
    } else {
      this.isWxEnv = false
    }
    this.initData()
  },
  mounted() {
    setTimeout(() => {
      document.addEventListener('click', this.handleDocumentClick);
      let _form = this.getCache("formAdvanceParams") || ""
      if (_form) {
        this.form = JSON.parse(_form)
      }
    }, 100)
  },
  methods: {
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)

          if (this.isWxEnv) {
            // 微信环境内
            window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
          } else {
            this.$store.commit('setShowLogin', true)
          }
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }

    },
    //关闭search_tips
    close_search_tips() {
      this.search_tips = false
    },
    //输入框获取焦点
    textarea_focus() {
      this.search_tips = true
    },
    //输入框失去焦点
    textarea_blur() {
      setTimeout(() => {
        this.search_tips = false
      }, 100)
    },
    //选择提示词
    choose_tips_item(item) {
      let _item = {...item}
      _item.progress = 0
      this.sampleUserList = JSON.parse(localStorage.getItem('sampleUserList') || "[]")
      this.sampleUserList = [_item].concat(this.sampleUserList);
      localStorage.setItem("sampleUserList", JSON.stringify(this.sampleUserList))

      this.$emit('select_sample', _item);
    },

    initData() {
      this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
    },
    choose_aspect(item) {
      this.form.aspect = item.size
    },
    handleDocumentClick(event) {
      // 判断点击的区域是否是 container 元素或其子元素
      if (this.$refs.container && !this.$refs.container.contains(event.target)) {
        // 点击了除 container 以外的区域，执行相应操作
        this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
      }
    },
    crefChange(index) {
      // cref 变化
      if (this.form.upload_list[index].is_cref) {
        let k = 0
        this.form.upload_list.forEach(e => {
          if (k != index) {
            this.form.upload_list[k].is_cref = false
          }
          k += 1
        })
      }
    },
    deleteUpload(index) {
      if (this.upoadLoading) {
        this.$message.error("正在上传，请稍后再操作！")
        return
      }
      let i = -1
      for (let k = 0; k < this.$refs.uploadImg.uploadFiles.length; k++) {
        if (this.form.upload_list[index].lastModified == this.$refs.uploadImg.uploadFiles[k].raw.lastModified) {
          i = k
        }

      }
      this.form.upload_list.splice(index, 1)
      this.fileList.splice(i, 1)
      this.$nextTick(() => {
        this.totalNum = this.$refs.uploadImg.uploadFiles.length;
      })
    },
    handleChange(file, fileList) {
      if (this.upoadLoading) {
        this.$message.error("正在上传，请稍后再操作！")
        return
      }

      if (this.form.upload_list.length >= 4) {
        return
      }
      if (file.raw.type != "image/jpeg" && file.raw.type != "image/png") {
        this.$message({
          message: '仅支持JPG、PNG格式图片',
          type: 'warning'
        })
        this.$refs.uploadImg.clearFiles()
        this.totalNum = this.$refs.uploadImg.uploadFiles.length;
        return
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          message: '请上传10M以内的图片',
          type: 'warning'
        })
        this.$refs.uploadImg.clearFiles()
        this.totalNum = this.$refs.uploadImg.uploadFiles.length;
        return
      }

      let img_src = URL.createObjectURL(file.raw);
      let flag = true
      this.form.upload_list.forEach(e => {
        if (e.lastModified == file.raw.lastModified) {
          flag = false
        }
      })
      if (flag) {
        this.form.upload_list.push({
          img_src: img_src,
          img_url: "",
          sref: 0,
          is_sref: 0,
          cref: 0,
          is_cref: 0,
          lastModified: file.raw.lastModified
        })
      } else {
        this.$message.error("请勿上传重复图片")
      }
      this.totalNum = this.$refs.uploadImg.uploadFiles.length;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 4 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    handleSuccess(response, file, fileList) {
      console.log("handleSuccess", response, file)
    },
    async submitUpload() {
      this.okNum = 0
      this.totalNum = this.$refs.uploadImg.uploadFiles.length;
      if (this.totalNum <= 0) {
        this.$message.error("没有需要上传的文件")
        return
      }
      this.upoadLoading = true
      for (let index = 0; index < this.$refs.uploadImg.uploadFiles.length; index++) {
        this.okNum += 1
        const f = this.$refs.uploadImg.uploadFiles[index];
        await this.uploadFile(f)
      }
      this.$refs.uploadImg.clearFiles()
      this.totalNum = this.$refs.uploadImg.uploadFiles.length;
      this.upoadLoading = false
      this.$message.success("图片上传完成！")
    },
    async uploadFile(file) {
      let lastModified = file.raw.lastModified
      this.uploadError = ""
      let post_url = await this.$http.get(`${FILE_API_SERVER}/api/front/upload/?file_folder=mj_iw`).then(res => {
        return res.data
      }).catch(e => {
        return ""
      });
      if (!post_url) {
      }
      // 上传图片
      let formData = new FormData();
      formData.append("file", file.raw, file.name);
      let fileResponse = await this.$http.post(post_url, formData, {
        headers: {"Content-Type": "multipart/form-data"},
        responseType: "text"
      }).then(res => {
        return eval(res);
      }).catch(e => {
        return "";
      });
      this.uploadError = fileResponse.data.error
      let file_full_url = fileResponse.data.file_full_url
      this.form.upload_list.forEach(e => {
        if (e.lastModified == lastModified) {
          e.img_url = file_full_url
          e.img_src = file_full_url
        }
      })
    },
    //发送消息
    sendMsg() {
      console.log('发送消息')
      if (!this.checkLogin()) return
      if(!utils.setOptData(this.userInfo,'btn_sd_create')){
          return
      }
      this.inputVal = this.inputVal.trim();
      // 绘画描述
      if (!this.inputVal && this.navCall !== 3) {
        this.$message.warning('请输入文字信息')
        return
      }
      if (this.navCall === 3 || this.navCall === 2) {
        if (this.imageUrl === '' || this.imageUrl === null) {
          this.$message.warning('上传图片')
          return;
        }
      }

      if (this.sending) {
        this.$message.warning('请等待上次绘图完成')
        return
      }

      if (this.auto_spell > 0) {
        console.log('ai提示词')
        if (!this.perIncan) {
          this.$store.commit('setisInputVal', this.inputVal)
          this.$store.commit('setisInputtype', 'Stable Diffusion')
          this.$store.commit('setisInputValshow', true)
          return;
        }
      }
      let parameters = {
        iw: 0.02 * this.value1,
        aspect: this.form.aspect,// 大小比例 this.imgSize[this.imgSizeNum+1].name
        // tips_text:"",
        quality: 0,
        stylize: 100,
        chaos: 100,
        upload_list: this.navCall === 1 || this.navCall === 3 ? [] : [this.imageUrl]
      }

      let inputs = this.checkpointList[this.checkpoint + 1].title

      // 单图四图
      let pic_num = 4;
      if (this.drawingModeNum === 2) {
        //单图
        pic_num = 1
      } else {
        // 四图
        pic_num = 4
      }
      // 同步请求
      this.submitQuestion({
        question: this.navCall === 3 ? this.inputVal + inputs : this.inputVal,
        parameters: parameters,
        img_model: this.clickImgStyleList[this.clickImgStyle.num - 1].desc ? "MJ6.0" : this.img_model,
        is_fast: this.is_fast,
        fg_tips: '',

        iw_url: this.upload_img_url,
        iw: 0.02 * this.value1,
        model: 1,
        pic_num: pic_num
      });

    },
    submitQuestion(data, parent_msg_code, i) {
      console.log('提交')
      console.log(data)
      // return
      this.sending = true;
      // 提交问题
      data.source = "pc";
      this.perIncan = false

      this.$http.post('/front/aisd/draw/', data).then((res) => {
        if (res.status == 200) {
          this.inputVal = "";
          // this.checkIds.push(res.data.draw.draw_id)
          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });
          // this.fetchMsg();
          this.$emit('submitForm', {})
        } else {
          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              console.log('进入会员中心')
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          } else if (message == "no_face_verify") {
            // 实名认证
            this.$refs.faceVerifyPopup.show()
            return
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
        }
      }).finally(() => {
        this.sending = false;

      })
    },
    SdLeftClick(item, name) {
      // 跳转列表
      if (name === 'leftList') {
        this.navCall = item.num
        // 跳转清空
      }
      if (name === 'size') {
        this.imgSizeNum = item.num
      }
    },
    clickLoraStyleList(item, modle) {
      if (modle) {
        this.LoraListStyle.sign = item.sign
        this.LoraListStyle.num = item.num
        this.LoraListStyle.shou = item.shou
        return
      }
      this.clickImgStyle.sign = item.sign
      this.clickImgStyle.num = item.num
      this.clickImgStyle.shou = item.shou

    },
    // 上传图片
    handleAvatarSuccess(res, file) {
      if (res.data.error !== "") {
        this.$message.error(res.data.error);
        return
      }
      this.imageUrl = res.data.file_full_url
    },
    beforeAvatarUpload(file) {

      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message({
          message: '仅支持JPG、PNG格式图片',
          type: 'warning'
        })
        return
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          message: '请上传10M以内的图片',
          type: 'warning'
        })
        return
      }
    },
    showDefeatPopup(name) {
      // this.$refs.defeatPopup.show();
      if (name === 'showDefeat') {
        this.$refs.conditionPopup.show();
      } else if (name === 'loraStyle') {
        this.$refs.loraStyle.show();
      } else {
        this.$refs.defeatPopup.show();
      }
    },
    defeatPopClose(name) {
      if (name === 'showDefeat') {
        this.$refs.conditionPopup.close();
      } else if (name === 'loraStyle') {
        this.$refs.loraStyle.close();
      } else {
        this.$refs.defeatPopup.close();
      }
    },
    clickConditionList(item, index, mode) {
      if (mode === 'clear') {
        this.conditionListSelect = []
        this.conditionList.forEach((item) => {
          item.select = false
        })
        return
      }
      if (mode === 'reduce' || mode === 'adds') {
        if (mode === 'reduce') {
          let num1 = Number(this.conditionListSelect[index].scale).toFixed(1)
          let num2 = Number(0.1).toFixed(1)
          let num3 = (num1 - num2).toFixed(1)
          num3 >= 0.1 ? this.conditionListSelect[index].scale = num3 : this.conditionListSelect[index].scale = 0
        } else {
          let num1 = Number(this.conditionListSelect[index].scale).toFixed(1)
          let num2 = Number(0.1).toFixed(1)
          let num3 = Number(num1) + Number(num2)
          num3.toFixed(1) <= 1.9 ? this.conditionListSelect[index].scale = num3.toFixed(1) : this.conditionListSelect[index].scale = 2
        }
        return;
      }
      if (this.conditionList[index].select) {
        this.conditionList[index].select = false
        this.conditionListSelect.forEach((Listitem, Listindex) => {
          if (Listitem.num === item.num) {
            this.conditionListSelect.splice(Listindex, 1)
          }
        })
      } else {
        if (this.conditionListSelect.length <= 1) {
          this.conditionListSelect.push(item)
          this.conditionList[index].select = true
        } else {
          this.$message({
            message: '最多选择两个模型',
            type: 'warning'
          });
        }
      }
    },
    clickLoraList(item, index, mode) {
      if (mode === 'delete') {
        this.LoraListSelect.splice(item, 1)
        this.clickImgStyleList.forEach((items, indexs) => {
          if (items.num === item.num) {
            this.clickImgStyleList[indexs].select = false
          }
        })
        return
      }
      if (mode === 'reduce' || mode === 'adds') {
        if (mode === 'reduce') {
          let num1 = Number(this.LoraListSelect[index].scale).toFixed(1)
          let num2 = Number(0.1).toFixed(1)
          let num3 = (num1 - num2).toFixed(1)
          num3 >= 0.1 ? this.LoraListSelect[index].scale = num3 : this.LoraListSelect[index].scale = 0
        } else {
          let num1 = Number(this.LoraListSelect[index].scale).toFixed(1)
          let num2 = Number(0.1).toFixed(1)
          let num3 = Number(num1) + Number(num2)
          num3.toFixed(1) <= 0.9 ? this.LoraListSelect[index].scale = num3.toFixed(1) : this.LoraListSelect[index].scale = 1
        }
        return;
      }
      if (mode === 'clear') {
        this.LoraListSelect = []
        this.clickImgStyleList.forEach((item) => {
          item.select = false
        })
        return
      }
      if (this.clickImgStyleList[index].select) {
        this.clickImgStyleList[index].select = false
        this.LoraListSelect.forEach((Listitem, Listindex) => {
          if (Listitem.num === item.num) {
            this.LoraListSelect.splice(Listindex, 1)
          }
        })
      } else {
        if (this.LoraListSelect.length <= 1) {
          this.LoraListSelect.push(item)
          this.clickImgStyleList[index].select = true
        } else {
          this.$message({
            message: '最多选择两个模型',
            type: 'warning'
          });
        }
      }
    },

    getPromptData4() {
      // 关闭
      console.log('auto_spell', this.auto_spell)
      if (this.auto_spell == 0) {
        this.$confirm('关闭自动优化描述词，生成的绘画内容可能不佳，请谨慎关闭!', '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auto_spell = '0'
        }).catch(() => {
          this.auto_spell = '1'

        });
      }
    },

  },
  watch: {
    '$store.state.isInputValshow'(newVal) {
      console.log('isInputValshow 变化0:', newVal);
      if (!newVal) {
        if (this.isInputtype.length > 0) {
          this.perIncan = true
          this.inputVal = this.isInputVal
          this.sendMsg()
        }
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick);
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.fg1 {
  flex: 1;
}

#AdvancedOptions {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  color: #fff;
  background-color: #2b2d31;

  .content_area {
    overflow: hidden;
    flex: 1 1 0%;

    .left_nav {
      margin: 10px 20px;
      padding: 4px 0;
      height: 40px;
      border-radius: 6px;
      border: 1px solid #36373d;
      display: flex;
      align-items: center;
      color: #fff;
      background-color: #313338;

      div {
        flex: 1;
        text-align: center;
        margin: 0 4px;
        cursor: pointer;
      }

      .navSelected {
        background-color: #5865f2;
        border-radius: 4px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .form_wrap {
      overflow-y: auto;
      padding: 5px 15px 60px;
      height: 100%;
    }

    .toolsIntroduce {
      background-color: #1e1f22;
      padding: 16px 14px;
      display: flex;
      border-radius: 5px;
      box-sizing: border-box;
      overflow: hidden;

      .left {
        width: 20px;
        margin-right: 12px;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .right {
        width: calc(100% - 32px);
        flex-grow: 1;
        word-wrap: break-word;

        p {
          font-size: 14px;
          font-weight: 700;
          height: 20px;
          margin-bottom: 5px;
        }

        span {
          font-size: 12px;
          word-wrap: break-word;
          white-space: normal;
        }

      }
    }


    .options_item {
      margin: 10px 0 10px;

      .item_title {
        margin-bottom: 10px;

        .text {
          position: relative;
          padding-left: 10px;
          white-space: normal;

          &:before {
            content: "";
            width: 4px;
            height: 15px;
            background: #5865f2;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 4px;
          }

          .icon {
            font-size: 15px;
            margin: 0 0 -2px 10px;
            color: #4a4c52;
            font-weight: bold;
          }
        }
      }

      .item_con {
        .el-switch {
          margin-left: 10px;
        }
      }
    }
  }

  .bottom_area {
    padding-top: 10px;
    background-color: #2b2d31;
    height: 90px;
    width: 100%;
    padding: 0 30px;

    .primary_button {
      font-size: 16px;
      height: 46px;
      padding-top: 13px;
      padding-bottom: 13px;
      border-radius: 9999px;
      flex: 1 1 0%;
    }
  }
}

.btm_area_con {
  //position: relative;
  border-radius: 5px;
  border: 2px solid #5865f2;
  padding: 10px 10px;

  .text {
    width: 100%;
    background-color: #2b2d31;
    border: 0;
    color: #b4b9bf;
    font-size: 14px;
    letter-spacing: 1.5px;
    line-height: 20px;
  }

  .depict_switch {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    margin-top: 10px;
    line-height: 1;

    .switch {
      display: flex;
      align-items: center;

      span {
        margin-left: 10px;
      }
    }

    .empty {
      color: #b4b9bf;
      cursor: pointer;
    }

    .empty:hover {
      color: #fff;
    }
  }
}

.image_quality {
  //display: grid;
  //grid-template-columns: 1fr 1fr 1fr;
  //gap: 10px;
  .quality {
    display: flex;
    color: #fff;
    font-size: 14px;

    .quality_btn {
      border: 2px solid #393c43;
      border-radius: 3px;
      background-color: #1d2027;
      padding: 10px 50px;
      margin: 0 20px 0 0;
      cursor: pointer;
    }

    .quality_btns {
      border: 2px solid #5865f2;
      border-radius: 3px;
      background-color: #303245;
      padding: 10px 50px;
      margin: 0 20px 0 0;
      cursor: pointer;
    }

  }

  .brief {
    color: #7E7E7E;
    font-size: 14px;
    margin: 8px 0;
  }
}

.model_list {
  display: flex;


  .model_item {
    border-radius: 6px;
    border: 2px solid #1d2027;
    position: relative;
    overflow: hidden;

    &.active {
      border-color: #5865f2;
    }

    img {
      border: none;
      width: 100%;
    }

    .model_title {
      position: absolute;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.73);
      height: 25px;
      font-size: 12px;
      left: 0;
      bottom: 0;
    }
  }

  .quality {
    display: flex;
    color: #fff;
    font-size: 14px;

    .quality_btn {
      border: 2px solid #393c43;
      border-radius: 3px;
      background-color: #1d2027;
      padding: 10px 35px;
      margin: 0 20px 0 0;
      cursor: pointer;
    }

    .quality_btns {
      border: 2px solid #5865f2;
      border-radius: 3px;
      background-color: #303245;
      padding: 10px 35px;
      margin: 0 20px 0 0;
      cursor: pointer;
    }

  }

}


.size_list {
  padding-top: 14px;
  flex-wrap: wrap;
  gap: 5px 2px;

  .size_item {
    border: 2px solid #393c43;
    width: 70px;
    height: 100px;
    //margin-right: 10px;
    //margin-bottom: 10px;
    border-radius: 4px;
    cursor: pointer;

    img {
      width: 36px;
      height: 40px;
    }

    p {
      font-size: 12px;
      color: #8e9093;
      margin-top: 6px;
    }

    &.active {
      border: 2px solid #5865f2;
    }
  }
}

.toolsModelList {

  //scrollbar-width: thin;
  .music_style {
    overflow-x: auto;
    width: 100%;
    white-space: nowrap;
    padding: 0 0 5px 0;

    span {
      font-size: 14px;
      margin-right: 15px;
      cursor: pointer;

    }

    .spanColor {
      color: #5865f2;
    }
  }

  .music_styleImg {
    padding: 0 0 0 0;
    display: flex;
    flex-wrap: wrap;

    //height: 270px;
    overflow: hidden;
    gap: 2% 2%;

    .styleImg_item {
      //width: 83px;
      //height: 83px;
      width: 32%;
      position: relative;
      border: 2px solid #5865f200;
      border-radius: 5px;
      overflow: hidden;
      margin: 2px 0;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }

      div {
        width: 100%;
        padding: 2px 0;
        text-align: center;
        font-size: 12px;
        background-color: #000000ac;
        position: absolute;
        left: 0;
        bottom: 0;

      }

    }

    .item_click {
      border: 2px solid #5865f2;
      //width: 83px;
      //height: 83px;
      width: 32%;
      position: relative;
      border-radius: 5px;
      margin: 2px 0;
      cursor: pointer;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }

      div {
        width: 100%;
        padding: 2px 0;
        text-align: center;
        font-size: 12px;
        background-color: #000000ac;
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
  }

  .upDown {
    background-color: #1e1f22;
    padding: 5px 0;
    display: flex;
    cursor: pointer;

    img {
      margin: 0 auto;
    }
  }

}

.drawingMode {
  display: flex;
  justify-content: space-between;

  .itemMode {
    text-align: center;
    width: 45%;
    padding: 10px 35px;
    background-color: #1d2027;
    border-radius: 3px;
    border: 2px solid #5865f200;
    cursor: pointer;
    position: relative;

    .vip {
      position: absolute;
      color: #f0b132;
      font-size: 14px;
      font-weight: 700;
      top: -11px;
      right: 0;
    }
  }

  .mode {
    text-align: center;
    width: 45%;
    padding: 10px 35px;
    background-color: #1d2027;
    border-radius: 3px;
    border: 2px solid #5865f2;
    cursor: pointer;
    position: relative;

    .vip {
      position: absolute;
      color: #f0b132;
      font-size: 14px;
      font-weight: 700;
      top: -11px;
      right: 0;
    }
  }
}

.picture_sel {
  background-color: #1e1f22;
  padding: 16px 14px;
  border-radius: 5px;

  .picture_top {
    display: flex;

    .upload_img {
      width: 100px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px dashed #cedffe80;
      border-radius: 5px;
      overflow: hidden;

      .noUpload {
        color: #c0c4cc;

        .el-icon-plus {
          font-size: 30px;
          font-weight: 700;
        }

        .noUpload_text {
          font-size: 14px;
        }
      }

      .hoverImg {
        display: none;
      }
    }

    .upload_img:hover {
      .hoverImg {
        width: 100px;
        height: 100px;
        background-color: #67676982;
        font-size: 16px;
        line-height: 100px;
        text-align: center;
        display: block;
        color: white;
      }
    }


    .style_strength {
      flex: 1;
      padding: 0 0 0 10px;
      font-size: 14px;
      color: #b4b9bf;

      .strength_top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
      }

      .strength_bot {
        /deep/ .el-slider__bar {
          height: 6px;
          background-color: #5865f2;
          border-top-left-radius: 3px;
          border-bottom-left-radius: 3px;
          position: absolute;
        }

        /deep/ .el-slider__button {
          border: 2px solid #5865f2;
        }

      }
    }

  }

  .picture_bot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;

    .one {
      font-size: 13px;
      margin-bottom: 5px;
    }

    .two {
      font-size: 12px;
      color: #b4b9bf;
    }

    .three {
      font-size: 14px;
      color: #b4b9bf;
      display: flex;
      align-items: center;

      span {
        margin-right: 5px;
      }
    }
  }

}

.Reference_image {
  width: 100%;
  height: 140px;
  overflow: hidden;
  box-sizing: border-box;

  .upload-demo {
    width: 100%;
    height: 100%;
  }

  /deep/ .el-upload-dragger {
    width: 100%;
    background-color: #1d2027;
    border-color: #3e4149;
    height: 140px;
  }

  /deep/ .el-upload-dragger:hover {
    border-color: #5865f2;
    height: 140px;
  }

  /deep/ .el-upload {
    width: 100%;
  }

  .noUpload {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #606266;
  }

  .yesUpload {
    position: relative;

    .yesUpload_img {
      height: 140px;
    }

    .yesUpload_icon {
      position: absolute;
      right: 8px;
      bottom: 12px;
      //background-color: aquamarine;
      color: #c1bfbb;
      font-size: 25px;
    }


  }
}

.ControlNet {
  height: 80px;
  background-color: #1d2027;
  border-radius: 5px;
  font-size: 14px;
  color: #aaaaaa;

  .ControlNet_one {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .ControlNet_two {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .left {

      .conditionSelect {
        width: 200px;
        height: 25px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #36373d;
        padding: 0 10px;
        border-radius: 3px;
        margin: 5px 0;

        .reduce {
          font-size: 20px;
          cursor: pointer;
        }

        .add {
          font-size: 20px;
          cursor: pointer;
        }

        .title {
          font-size: 13px;
        }
      }
    }

    .right {
      margin: 0 0 0 5px;
    }

  }

}

.condition_Popup {
  width: 350px;
  //height: 560px;
  background-color: #000000;
  border: 2px solid #5865f2;
  color: #d6d6d6;
  padding: 10px;
  border-radius: 5px;
  box-sizing: border-box;

  .conditionTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    font-size: 15px;
    font-weight: 700;

    .clear {
      cursor: pointer;
      width: 30px;
      height: 30px;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;

      .el-icon-error {
        font-size: 20px;
        color: #565658;
      }
    }

    .clear:hover {
      background-color: #343538;
    }
  }

  .conditionTips {
    color: #d6d6d6;
    font-size: 13px;
    margin: 10px 0;
  }

  .conditionShow {
    display: flex;
    justify-content: space-between;
    margin: 0 0 10px 0;

    .conditionSelect {
      width: 45%;
      height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #1a1a1a;
      padding: 0 10px;
      border-radius: 3px;

      .reduce {
        font-size: 20px;
        cursor: pointer;
      }

      .add {
        font-size: 20px;
        cursor: pointer;
      }

      .title {
        width: 85px;
        font-size: 13px;
        overflow: hidden;

      }
    }
  }

  .condition_List {
    height: 410px;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .List_itme {
      width: 48%;
      height: 135px;
      border: 2px solid #5865f200;
      border-radius: 12px;
      overflow: hidden;
      cursor: pointer;
      background-color: #373737;

      .item_img {
        width: 100%;
      }

      .title {
        padding: 1px 8px;

        div {
          font-size: 13px;
          color: #FFFFFF;
        }

        span {
          font-size: 12px;
          color: #AAAAAA;
          word-wrap: break-word;
          white-space: normal;
        }
      }
    }

    .List_itmes {
      border: 2px solid #5865f2;
      width: 48%;
      height: 135px;
      border-radius: 12px;
      overflow: hidden;
      cursor: pointer;
      background-color: #373737;

      .item_img {
        width: 100%;
      }

      .title {
        padding: 1px 8px;

        div {
          font-size: 13px;
          color: #FFFFFF;
        }

        span {
          font-size: 12px;
          color: #AAAAAA;
          word-wrap: break-word;
          white-space: normal;
        }
      }
    }
  }

  .conditionBtn {
    display: flex;
    justify-content: center;
    margin: 10px 0 0 0;
    cursor: pointer;

    div {
      width: 100px;
      height: 30px;
      margin: 0 10px;
      border-radius: 15px;
      text-align: center;
      line-height: 30px;
      font-size: 13px;
    }

    div:nth-child(1) {
      background-color: #3c434a;
      color: #FFFFFF90;
    }

    div:nth-child(2) {
      background-color: #5865f2;
      color: #FFF;
    }
  }
}

.parameter {
  width: 100%;
  padding: 15px 15px;
  border-radius: 6px;
  background-color: #1d2027;
  font-size: 14px;

  .parameter_title {
    margin: 0 0 5px 0;
  }

  .parameter_slider {
    border-bottom: 1px solid #282B31;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0 10px 0;
    margin: 0 0 10px 0;

    .slider_num {
      width: 40px;
      height: 28px;
      background-color: #2d313b;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;

    }

    .slider {
      flex: 1;
      margin: 0 0 0 10px;

      /deep/ .el-slider__bar {
        background-color: #5865f2;
      }

      /deep/ .el-slider__button {
        border-color: #FFF;
        cursor: grab;
      }
    }
  }

  .Negative_Prom {
    .Negative_text {
      width: 100%;
      height: 50px;
      background-color: #313338;
      border: 2px solid #393c43;
      color: #c7d2c9;
      padding: 5px 5px;
      font-size: 14px;
      border-radius: 4px;
    }

    textarea::placeholder {
      color: #a8abb2; /* 将颜色改为灰色 */
    }

  }
}

.checkpoint {
  display: flex;
  white-space: nowrap;
  justify-content: space-between;

  .checkpoint_item {
    width: 100px;
    //height: 75px;
    position: relative;
    border-radius: 5px;
    overflow: hidden;
    border: 2px solid #00000000;
    cursor: pointer;

    img {
      object-fit: cover;

    }

    div {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: #000000ba;
      font-size: 12px;
      text-align: center;
      padding: 5px 0;
    }
  }

  .checkpoint_items {
    width: 100px;
    position: relative;
    border-radius: 5px;
    overflow: hidden;
    border: 2px solid #5865f2;
    cursor: pointer;

    img {
      object-fit: cover;
    }

    div {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: #000000ba;
      font-size: 12px;
      text-align: center;
      padding: 5px 0;
    }
  }

}

.fusionStyle {
  .fusionStyle_one {
    //height: 54px;
    width: 100%;
    border: 1px solid #393d45;
    border-radius: 6px;
    background-color: #1d2027;
    padding: 10px 10px;
    font-size: 12px;
    color: #abb0b6;
    display: flex;
    //justify-content: space-between;
    align-items: center;
    cursor: pointer;

    .fusionStyle_oneLeft {
      padding: 10px 10px;
      border: 1px dashed #393d45;
      border-radius: 6px;
    }

    .fusionStyle_oneLeft:hover {
      color: #cccccc;
    }

    .fusionStyle_oneRight {
      margin: 0 0 0 20px;

      span {
        font-size: 14px;
        color: #cccccc;
      }

      div {
        margin: 5px 0 0 0;
      }
    }
  }

  .fusionStyle_two {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .two_Imgs {
      width: 130px;
      height: 100px;
      background-color: #000000;
      overflow: hidden;
      text-overflow: ellipsis;
      border-radius: 8px;

      .two_Img {
        width: 130px;
        height: 70px;
        white-space: nowrap;
        position: relative;

        img {
          width: 100%;
          height: 70px;
          object-fit: cover;
        }

        .closes {
          position: absolute;
          top: 0;
          right: 0;
          width: 25px;
          height: 25px;
          border-bottom-left-radius: 6px;
          background-color: #0000007a;
          cursor: pointer;
          padding: 0 5px;
          // 穿透更改图标大小
          /deep/ i.el-icon-error {
            font-size: 16px;
            color: #b4afb0;
            line-height: 25px;

          }

          /deep/ i.el-icon-error:hover {
            font-size: 16px;
            color: #ffffff;
          }
        }

        .title {
          width: 100%;
          font-size: 12px;
          background-color: #000000ba;
          text-align: center;
          padding: 5px 0;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }

      .two_bot {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        height: 30px;

        div:nth-child(1) {
          font-size: 20px;
          font-weight: 700;
          cursor: pointer;
        }

        div:nth-child(3) {
          font-size: 20px;
          font-weight: 700;
          cursor: pointer;
        }
      }
    }

  }
}

.loraStyle_Popup {
  width: 300px;
  background-color: #000000;
  border: 2px solid #5865f2;
  color: #d6d6d6;
  padding: 20px;
  border-radius: 5px;

  .conditionTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    font-size: 15px;
    font-weight: 700;

    .clear {
      cursor: pointer;
      width: 30px;
      height: 30px;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;

      .el-icon-error {
        font-size: 20px;
        color: #565658;
      }
    }

    .clear:hover {
      background-color: #343538;
    }


  }

  .conditionTips {
    color: #d6d6d6;
    font-size: 13px;
    margin: 10px 0;
    word-wrap: break-word;
    white-space: normal;
  }

  .conditionShow {
    display: flex;
    justify-content: space-between;
    margin: 0 0 10px 0;

    .conditionSelect {
      width: 47%;
      height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #1a1a1a;
      padding: 0 10px;
      border-radius: 3px;

      .reduce {
        font-size: 20px;
        cursor: pointer;
      }

      .add {
        font-size: 20px;
        cursor: pointer;
      }

      .title {
        font-size: 13px;
      }
    }
  }

  .music_style {
    overflow-x: auto;
    width: 100%;
    white-space: nowrap;
    padding: 0 0 5px 0;

    span {
      font-size: 14px;
      margin-right: 15px;
      cursor: pointer;

    }

    .spanColor {
      color: #5865f2;
    }
  }

  .condition_List {
    height: 410px;
    overflow-y: auto;


    .music_styleImg {
      padding: 0 0 0 0;
      display: flex;
      flex-wrap: wrap;

      //height: 270px;
      overflow: hidden;
      gap: 5px 2%;

      .styleImg_item {
        width: 32%;
        //height: 90px;
        position: relative;
        border: 2px solid #5865f200;
        border-radius: 5px;
        overflow: hidden;
        margin: 2px 0;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }

        div {
          width: 100%;
          padding: 2px 0;
          text-align: center;
          font-size: 12px;
          background-color: #000000ac;
          position: absolute;
          left: 0;
          bottom: 0;

        }

      }

      .item_click {
        border: 2px solid #5865f2;
        width: 32%;
        //height: 91px;
        position: relative;
        border-radius: 5px;
        margin: 2px 0;
        cursor: pointer;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }

        div {
          width: 100%;
          padding: 2px 0;
          text-align: center;
          font-size: 12px;
          background-color: #000000ac;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }

    .upDown {
      background-color: #1e1f22;
      padding: 5px 0;
      display: flex;
      cursor: pointer;

      img {
        margin: 0 auto;
      }
    }

  }

  .conditionBtn {
    display: flex;
    justify-content: center;
    margin: 10px 0 0 0;
    cursor: pointer;

    div {
      width: 100px;
      height: 30px;
      margin: 0 10px;
      border-radius: 15px;
      text-align: center;
      line-height: 30px;
      font-size: 13px;
    }

    div:nth-child(1) {
      background-color: #3c434a;
      color: #FFFFFF90;
    }

    div:nth-child(2) {
      background-color: #5865f2;
      color: #FFF;
    }
  }
}


.popup {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1501;
  bottom: 0;
  left: 0;
  transition: all 0.3s;
  background: rgba(0, 0, 0, 0.8);
  overflow: auto;
  animation: fadeInSlowAni 0.3s 1;

  .centerPanel {
    position: fixed;
    z-index: 1501;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: transform 0.2s;
  }
}

/deep/ .el-loading-mask {
  background: none;
}

@media screen and (min-width: 320px) {
  .condition_Popup {
    width: 310px;
  }
  .loraStyle_Popup {
    width: 310px;
  }
}

@media screen and (min-width: 375px) {
  .condition_Popup {
    width: 360px;
  }
  .loraStyle_Popup {
    width: 360px;
  }
  .size_list {
    gap: 10px 11px;
  }
}

@media screen and (min-width: 425px) {
  .condition_Popup {
    width: 410px;

    .condition_List {
      .List_itme {
        height: 155px;

      }

      .List_itmes {
        height: 155px;
      }
    }
  }
  .checkpoint {
    .checkpoint_item {
      width: 18%;
    }

    .checkpoint_items {
      width: 18%;
    }
  }
  .loraStyle_Popup {
    width: 410px;
  }
  .size_list {
    gap: 10px 11px;
  }
}

@media screen and (min-width: 768px) {
  .condition_Popup {
    width: 740px;

    .condition_List {
      gap: 10px 1%;

      .List_itme {
        height: 155px;
        width: 32%;
      }

      .List_itmes {
        height: 155px;
        width: 32%;
      }
    }

    .conditionShow .conditionSelect .title {
      width: 150px;
      font-size: 13px;
      overflow: hidden;

    }
  }
  .loraStyle_Popup {
    width: 740px;

    .condition_List {
      height: 410px;
      overflow-y: auto;


      .music_styleImg {
        padding: 0 0 0 0;
        display: flex;
        flex-wrap: wrap;

        //height: 270px;
        overflow: hidden;
        gap: 5px 10px;

        .styleImg_item {
          width: 90px;
          height: 90px;
          position: relative;
          border: 2px solid #5865f200;
          border-radius: 5px;
          overflow: hidden;
          margin: 2px 0;
          cursor: pointer;

          img {
            width: 100%;
            height: 100%;
          }

          div {
            width: 100%;
            padding: 2px 0;
            text-align: center;
            font-size: 12px;
            background-color: #000000ac;
            position: absolute;
            left: 0;
            bottom: 0;

          }

        }

        .item_click {
          border: 2px solid #5865f2;
          width: 91px;
          height: 91px;
          position: relative;
          border-radius: 5px;
          margin: 2px 0;
          cursor: pointer;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }

          div {
            width: 100%;
            padding: 2px 0;
            text-align: center;
            font-size: 12px;
            background-color: #000000ac;
            position: absolute;
            left: 0;
            bottom: 0;
          }
        }
      }

      .upDown {
        background-color: #1e1f22;
        padding: 5px 0;
        display: flex;
        cursor: pointer;

        img {
          margin: 0 auto;
        }
      }

    }


  }

}
</style>
